import { httpSingleton } from '@/lib/http-client';

export type TokensHolder = {
	accessToken: string;
	refreshToken?: string;
};

type SignInResponse = {
	encryptedAccessToken: string;
	encryptedRefreshToken: string;
};

export const accountService = {
	verifySignIn: async (accessToken: string, refreshToken: string) => {
		const response = await signIn(accessToken, refreshToken).fetch();
		return {
			accessToken: response.encryptedAccessToken,
			refreshToken: response.encryptedRefreshToken,
		};
	},
	rememberThisDevice: async (accessToken: string, deviceKey: string) => {
		await rememberThisDevice(accessToken, deviceKey).fetch();
	},
};

function signIn(accessToken: string, refreshToken: string) {
	return httpSingleton.orchestrateRequest<SignInResponse>({
		method: 'POST',
		url: `/auth-service/api/v1/account/sign-in`,
		headers: {
			Authorization: 'Bearer ' + accessToken,
			'X-Hackett-Refresh-Token': refreshToken,
		},
	});
}

export function rememberThisDevice(accessToken: string, deviceKey: string) {
	return httpSingleton.orchestrateRequest<undefined>({
		method: 'POST',
		url: `/auth-service/api/v1/account/remember-device`,
		headers: {
			Authorization: 'Bearer ' + accessToken,
		},
		data: { deviceKey },
	});
}
